// Determina il prossimo stato di una variante in base al ruolo, stato attuale e azione
export const determineNextStatus = (role, currentStatus, action) => {
    // Se l'azione è disabilitata, ritorna lo stato corrente
    if (action === "validate" && isValidateDisabled(role, currentStatus)) {
        return currentStatus;
    }
    if (action === "decline" && isDeclineDisabled(role, currentStatus)) {
        return currentStatus;
    }

    let newStatus = currentStatus;

    if (role === "Modellista") {
        if (currentStatus === "Rev. Modellista" && action === "validate") {
            newStatus = "Rev. Spaarkly";
        }
    }

    if (role === "Cliente") {
        if (currentStatus === "Rev. Cliente" && action === "validate") {
            newStatus = "In Pubblicazione";
        } else if (currentStatus === "Rev. Cliente" && action === "decline") {
            newStatus = "Rev. Modellista";
        } else if (currentStatus === "In Pubblicazione" && action === "validate") {
            newStatus = "Pubblicato";
        }
    }

    if (role === "Admin") {
        if (currentStatus === "Rev. Modellista" && action === "validate") {
            newStatus = "Rev. Spaarkly";
        } else if (currentStatus === "Rev. Spaarkly" && action === "validate") {
            newStatus = "Rev. Cliente";
        } else if (currentStatus === "Rev. Spaarkly" && action === "decline") {
            newStatus = "Rev. Modellista";
        } else if (currentStatus === "Rev. Cliente" && action === "validate") {
            newStatus = "In Pubblicazione";
        } else if (currentStatus === "Rev. Cliente" && action === "decline") {
            newStatus = "Rev. Spaarkly";
        } else if (currentStatus === "In Pubblicazione" && action === "validate") {
            newStatus = "Pubblicato";
        }
    }

    if (role === "ModellerSupervisor") {
        if (currentStatus === "Rev. Modellista" && action === "validate") {
            newStatus = "Rev. Spaarkly";
        } else if (currentStatus === "Rev. Spaarkly" && action === "validate") {
            newStatus = "Rev. Cliente";
        } else if (currentStatus === "Rev. Spaarkly" && action === "decline") {
            newStatus = "Rev. Modellista";
        } else if (currentStatus === "Rev. Cliente" && action === "validate") {
            newStatus = "In Pubblicazione";
        } else if (currentStatus === "Rev. Cliente" && action === "decline") {
            newStatus = "Rev. Spaarkly";
        } else if (currentStatus === "In Pubblicazione" && action === "validate") {
            newStatus = "Pubblicato";
        }
    }

    if (role === "Validator") {
        if (currentStatus === "Rev. Cliente" && action === "validate") {
            newStatus = "In Pubblicazione";
        } else if (currentStatus === "Rev. Cliente" && action === "decline") {
            newStatus = "Rev. Modellista";
        }
    }

    if (role === "Guest") {
        return currentStatus; // Il Guest non può mai cambiare lo stato
    }

    if (action === "start") {
        newStatus = "Rev. Modellista";
    }

    return newStatus;
};

// Verifica se il pulsante "validate" deve essere disabilitato
export const isValidateDisabled = (role, currentStatus) => {
    if (role === "Guest") {
        return true; // Sempre disabilitato per Guest
    }
    if (role === "Modellista") {
        return !["Rev. Modellista"].includes(currentStatus);
    }
    if (role === "Admin") {
        return !["Rev. Modellista", "Rev. Spaarkly", "Rev. Cliente", "In Pubblicazione"].includes(currentStatus);
    }
    if (role === "Cliente") {
        return !["Rev. Cliente", "In Pubblicazione"].includes(currentStatus);
    }
    if (role === "Validator") {
        return !["Rev. Cliente"].includes(currentStatus);
    }
    if (role === "ModellerSupervisor") {
        return !["Rev. Modellista", "Rev. Spaarkly", "Rev. Cliente", "In Pubblicazione"].includes(currentStatus);
    }
    return true;
};

// Verifica se il pulsante "decline" deve essere disabilitato
export const isDeclineDisabled = (role, currentStatus) => {
    if (role === "Guest") {
        return true; // Sempre disabilitato per Guest
    }
    if (role === "Modellista") {
        return true;
    }
    if (role === "Admin") {
        return !["Rev. Spaarkly", "Rev. Cliente"].includes(currentStatus);
    }
    if (role === "Cliente") {
        return !["Rev. Cliente"].includes(currentStatus);
    }
    if (role === "Validator") {
        return !["Rev. Cliente"].includes(currentStatus);
    }
    if (role === "ModellerSupervisor") {
        return !["Rev. Spaarkly", "Rev. Cliente"].includes(currentStatus);
    }
    return true;
};